export default __webpack_public_path__ + "static/media/iconai-generate.d6b41ed3.svg";